import React from 'react'
import styled from 'styled-components'
import utmLinkGenerator from '../utils/UTMLinkGenerator'
import { SIZES } from '../../constants'

const Link = styled.a`
  display: block;
  border: 0;
  margin: 0 0 20px 0;
`

const Image = styled.img`
  height: auto;
  width: 100%;
  
  @media (min-width: ${SIZES.BREAKPOINT_XS}px) {
    width: calc(100% + 2px);
  }
`

const ELECTION_LINK = 'https://zpravy.aktualne.cz/domaci/volebni-kalkulacka-parlamentni-volby-2021/r~6c11947803f211eca1070cc47ab5f122/'

export default props => {
  const {
    widget: {
      utmMeta
    },
    activeDynamicLayout
  } = props

  const imageSrc = `${STATICS_PATH}images/widgets/elections/volebni_kviz_${activeDynamicLayout}.png`

  const href = utmLinkGenerator.createLink(ELECTION_LINK, utmMeta)

  return <Link href={href}><Image src={imageSrc} alt='Banner volby'/></Link>
}
